<micro-select-combo #sel
              placeholder="DR Status"
              [mode]="mode"
              [(id)]="drStatus"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
